import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hcbhgx8v9w: FaireBrandEntity = {
  token: "b_hcbhgx8v9w",
  type: "brand",
  name: "123 Farm",
  avatarUrl:
    "https://cdn.faire.com/fastly/a4993b4dbfb17de94b2291d13c4bd5efcd68f0f113ab6456602b31be53db0414.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8d66467798c07a007a84cc6fdb4bee576670e4d7617d5fa045eb019d36fd292a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a4993b4dbfb17de94b2291d13c4bd5efcd68f0f113ab6456602b31be53db0414.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8d66467798c07a007a84cc6fdb4bee576670e4d7617d5fa045eb019d36fd292a.jpeg",
  location: "Cherry Valley, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 137,
  isTopShop: true,
  isInsider: true,
  description:
    "123 Farm is Southern California’s largest certified organic lavender farm, located on the historic Highland Springs Ranch & Inn in Cherry Valley. With a legacy that has welcomed notable guests such as Albert Einstein, Wyatt Earp, and Ernest Hemingway, the farm spans over 20 acres of blooming lavender and botanicals, rooted in a commitment to sustainability, wellness, and natural beauty.\n\nWhile many of our goods are made in California in small seasonal batches, we also offer a thoughtfully curated selection of goods—ranging from everyday lifestyle items to home and gift essentials—crafted in collaboration with trusted international partners. These items, produced under the 123 Farm and Flower Market labels, allow us to bring the calming, aromatherapeutic spirit of our farm to a broader audience, all while maintaining accessible price points.\n\nDue to limited harvests, not all of our farm-made products are available for wholesale. However, every item we offer reflects our core values: botanical-inspired living, environmental harmony, and the timeless charm of 123 Farm.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:02.398Z",
    importedBy: "entity-db-cli",
  },
};
